import http from "./HttpService";

var endpoint = `/user-management/`;
const headers = {};

const getUsers = async () => {
  const response = await http.get(`${endpoint}users`);
  return response;
};

const getRoles = async () => {
  const response = await http.get(`${endpoint}roleListing`, {
    headers: headers,
  });

  return response;
};

const checkEmailExists = async (email) => {
  const response = await http.head(`${endpoint}users/email/${email}`, {
    headers: headers,
  });

  return response;
};

const addUser = async (publicUser, serviceAcess) => {

  const response = await http.post(`${endpoint}public/register/${serviceAcess}`, publicUser,
    { headers: headers }
  );

  return response;
};

const updateUserProfile = async (profileValues) => {

  const response = await http.patch(`${endpoint}update/profile`, profileValues,
    {
      headers: headers,
    }
  );
  return response;

};

const updateUserDetails = async (values) => {
  const userId = values.id;

  const response = await http.put(`${endpoint}update/${userId}`, values,
    {
      headers: headers,
    }
  );
  return response;

};

const updateUserAccess = async (accessValues) => {

  const userId = accessValues.userId;
  const enabled = accessValues.enabled

  const response = await http.patch(`${endpoint}update/access/${userId}?enabled=${enabled}`,
    {
      headers: headers,
    }
  );
  return response;

};

const updateUserPassword = async (password) => {

  const response = await http.patch(`${endpoint}update/password?password=${password}`,
    {
      headers: headers,
    }
  );
  return response;

};

const programmeSubscription = async (serviceName) => {
  const response = await http.post(`${endpoint}public/subscribe/${serviceName}?acceptedPrivacy=${true}`, {headers: headers});
  return response;
};
export default {
  getUsers,
  getRoles,
  addUser,
  checkEmailExists,
  updateUserAccess,
  updateUserDetails,
  updateUserProfile,
  updateUserPassword,
  programmeSubscription
};

